document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.spring-sale-pre-part1');
  if (!section) return;

  var configNode =
    section.querySelector('[data-spring-sale-part1-config]') ||
    document.querySelector('.spring-sale-pre-part1 [data-spring-sale-part1-config]');
  var config = {};
  if (configNode) {
    try {
      config = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      config = {};
    }
  }

  var scratch = section.querySelector('.spring-sale-pre-part1__scratch');
  var scratchImg = section.querySelector('.spring-sale-pre-part1__scratch-img');
  var panel = section.querySelector('.spring-sale-pre-part1__panel');
  var emailKlv = section.querySelector('.spring-sale-pre-part1__email-klv');
  var winWrapper = section.querySelector('.spring-sale-pre-part1__win');
  var resultNotice = section.querySelector('.spring-sale-pre-part1 .result-notice');
  var modal = section.querySelector('.spring-sale-pre-part1__modal');
  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }
  var modalDialog = modal ? modal.querySelector('.spring-sale-pre-part1__modal-dialog') : null;
  var modalCanvas = modal ? modal.querySelector('.spring-sale-pre-part1__modal-canvas') : null;
  var modalHint = modal ? modal.querySelector('.spring-sale-pre-part1__modal-hint') : null;
  var modalResult = modal ? modal.querySelector('.spring-sale-pre-part1__modal-result') : null;
  var modalPrizeMedia = modal ? modal.querySelector('.spring-sale-pre-part1__modal-prize-media') : null;
  var modalPrizeTitle = modal ? modal.querySelector('.spring-sale-pre-part1__modal-prize-title') : null;
  var modalPrizeText = modal ? modal.querySelector('.spring-sale-pre-part1__modal-prize-text') : null;
  var modalHeart = modal ? modal.querySelector('.spring-sale-pre-part1__modal-heart') : null;

  var pendingPrizeIndex = null;
  var scratchRevealed = false;
  var scratchInstance = null;
  var currentPrizeResult = null;
  var modalCloseTimer = null;
  var MODAL_TRANSITION_MS = 320;
  var SCRATCH_WIDTH_RATIO = 738 / 802;
  var SCRATCH_HEIGHT_RATIO = 234 / 280;
  var SCRATCH_REVEAL_RATIO = 0.1;
  var SCRATCH_COMPLETE_RATIO = 0.99;
  var lotteryPreviewMode =
    Boolean(config.lotteryPreviewMode) || section.classList.contains('is-lottery-preview');
  var scheduleMbCardMeasure = null;
  var preloadedAssets = {};

  var defaultPrizeMap = [
    {
      title: '1st Prize:<br class="hide-pc">Gift Box featuring OpenFit 2+',
      text:
        'Congratulations!<br>You won a Gift Box featuring OpenFit 2+.<br>We will contact you by email before 9 October.',
      isWin: true,
      image: config.prizeImages && config.prizeImages[0]
    },
    {
      title: '2nd Prize:<br class="hide-pc">A$100 ASICS Digital Gift Card',
      text:
        'Congratulations!<br>You\'ve won a A$100 ASICS Digital Gift Card.<br>We will contact you by email before 9 October.',
      isWin: true,
      image: config.prizeImages && config.prizeImages[1]
    },
    {
      title: '3rd Prize:<br class="hide-pc">Pick your Shokz prize',
      text:
        'Congratulations!<br>You\'ve won a free Shokz prize of your choice. We will contact you by email before 9 October, so you can select your preferred prize.',
      isWin: true,
      image: config.prizeImages && config.prizeImages[2]
    },
    {
      title: 'Better luck!',
      text:
        'No prize this time, but more benefits are coming!<br>Spring Sale starts on Starts 28 October.',
      isWin: false,
      image: null
    }
  ];

  var prizeMap = (config.prizeResults || []).map(function (result, index) {
    return {
      title: result.title,
      text: result.text,
      isWin: result.isWin !== false,
      image: config.prizeImages && config.prizeImages[index] ? config.prizeImages[index] : null
    };
  });

  if (!prizeMap.length) {
    prizeMap = defaultPrizeMap;
  }

  if (modalHint && config.modalHintLines && config.modalHintLines.length) {
    modalHint.innerHTML = config.modalHintLines
      .map(function (line) {
        return '<p>' + line + '</p>';
      })
      .join('');
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function getModalBgUrl() {
    return isMobile() ? config.modalBgMb : config.modalBgPc;
  }

  function getScratchCoverUrl() {
    return isMobile() ? config.scratchCoverMb : config.scratchCoverPc;
  }

  function preloadImage(url) {
    if (!url) return Promise.resolve(null);
    if (preloadedAssets[url]) return preloadedAssets[url];

    preloadedAssets[url] = new Promise(function (resolve) {
      var image = new Image();
      image.decoding = 'async';
      image.onload = function () {
        resolve(image);
      };
      image.onerror = function () {
        resolve(null);
      };
      image.src = url;
    });

    return preloadedAssets[url];
  }

  function preloadModalAssets(prizeIndex) {
    var urls = [getModalBgUrl(), getScratchCoverUrl()];

    if (typeof prizeIndex === 'number' && prizeMap[prizeIndex] && prizeMap[prizeIndex].image) {
      urls.push(prizeMap[prizeIndex].image);
    } else if (config.prizeImages && config.prizeImages.length) {
      urls = urls.concat(config.prizeImages);
    }

    return Promise.all(
      urls.filter(Boolean).map(function (url) {
        return preloadImage(url);
      })
    );
  }

  function scheduleModalAssetPreload() {
    var run = function () {
      preloadModalAssets();
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 2000 });
    } else {
      window.setTimeout(run, 300);
    }
  }

  function shakeEmailKlv() {
    if (!emailKlv || winWrapper && winWrapper.classList.contains('is-visible')) return;
    emailKlv.classList.add('shake');
    window.setTimeout(function () {
      emailKlv.classList.remove('shake');
    }, 400);
  }

  function openPreviewModal() {
    if (!lotteryPreviewMode || !modal || !modal.hidden) return;
    var previewIndex = Math.floor(Math.random() * prizeMap.length);
    openModal(previewIndex);
  }

  function handleScratchImgActivate(event) {
    if (lotteryPreviewMode) {
      if (event && event.cancelable) {
        event.preventDefault();
        event.stopPropagation();
      }
      openPreviewModal();
      return;
    }
    shakeEmailKlv();
  }

  if (lotteryPreviewMode && scratch) {
    scratch.addEventListener('click', handleScratchImgActivate);
    scratch.setAttribute('role', 'button');
    scratch.setAttribute('tabindex', '0');
    scratch.setAttribute('aria-label', 'Open scratch card preview');
  } else if (scratchImg) {
    scratchImg.addEventListener('click', handleScratchImgActivate);
    scratchImg.setAttribute('role', 'button');
    scratchImg.setAttribute('tabindex', '0');
    scratchImg.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleScratchImgActivate(event);
      }
    });
  }

  if (lotteryPreviewMode && scratch) {
    scratch.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleScratchImgActivate(event);
      }
    });
  }

  function resetMbCardScroll() {
    section.classList.remove('is-panel-overlay');
    section.classList.remove('is-hero-pinned');
    section.classList.remove('is-card-scrolling');
    section.style.setProperty('--card-scroll-progress', '0');
    section.style.setProperty('--card-scroll-offset', '0px');
  }

  function initMbCardScroll() {
    var heroPin = section.querySelector('.spring-sale-pre-part1__hero-pin');
    var heroSticky = section.querySelector('.spring-sale-pre-part1__hero-sticky');
    var hero = section.querySelector('.spring-sale-pre-part1__hero');
    var card = section.querySelector('.spring-sale-pre-part1__card');
    var inner = section.querySelector('.spring-sale-pre-part1__inner');
    if (!heroPin || !heroSticky || !hero || !scratch || !card) return;

    var navGap = 12;
    var metrics = {
      maxOffset: 0,
      heroHeight: 0,
      stickyHeight: 0,
      anchorTop: 40,
      scrollStart: 0
    };
    var ticking = false;

    function getHeroPinTop() {
      var nav = document.getElementById('spring-sale-pre-nav');
      if (nav && nav.classList.contains('fixed')) {
        return nav.offsetHeight + navGap;
      }

      if (inner) {
        return parseFloat(window.getComputedStyle(inner).paddingTop) || 40;
      }

      return 40;
    }

    function syncScratchCardWidth() {
      var widthSource = scratchImg || scratch;
      if (!widthSource) return;
      section.style.setProperty('--scratch-sync-width', widthSource.getBoundingClientRect().width + 'px');
    }

    function updateScrollStart() {
      metrics.scrollStart = window.scrollY + heroPin.getBoundingClientRect().top - metrics.anchorTop;
    }

    function measure() {
      resetMbCardScroll();

      if (!isMobile()) {
        section.classList.remove('is-mb-scroll-ready');
        section.style.setProperty('--hero-pin-top', '40px');
        section.style.setProperty('--hero-sticky-height', '0px');
        section.style.setProperty('--card-scroll-travel', '0px');
        section.style.setProperty('--hero-pin-height', '0px');
        metrics.maxOffset = 0;
        metrics.scrollStart = 0;
        return;
      }

      metrics.anchorTop = getHeroPinTop();
      var cardRect = card.getBoundingClientRect();
      var heroRect = hero.getBoundingClientRect();
      var heroStyles = window.getComputedStyle(hero);
      var heroGap = parseFloat(heroStyles.rowGap || heroStyles.gap) || 0;
      // Subtract hero gap because it collapses to 0 during scroll alongside transform.
      metrics.maxOffset = Math.max(0, cardRect.top - heroRect.top - heroGap);
      metrics.heroHeight = hero.offsetHeight;
      metrics.stickyHeight = heroSticky.offsetHeight;
      syncScratchCardWidth();

      section.style.setProperty('--hero-pin-top', metrics.anchorTop + 'px');
      section.style.setProperty('--hero-sticky-height', metrics.stickyHeight + 'px');
      section.style.setProperty('--card-scroll-travel', metrics.maxOffset + 'px');
      section.style.setProperty('--hero-pin-height', metrics.heroHeight + 'px');
      section.classList.add('is-mb-scroll-ready');
      updateScrollStart();
    }

    function update() {
      ticking = false;

      if (!isMobile()) {
        resetMbCardScroll();
        return;
      }

      var scrolledInto = window.scrollY - metrics.scrollStart;
      var progress = 0;

      if (metrics.maxOffset > 0) {
        progress = scrolledInto / metrics.maxOffset;
        progress = Math.min(1, Math.max(0, progress));
      }

      var offset = progress * metrics.maxOffset;
      section.style.setProperty('--card-scroll-progress', String(progress));
      section.style.setProperty('--card-scroll-offset', offset + 'px');

      if (progress > 0 && progress < 1) {
        section.classList.add('is-hero-pinned');
        section.classList.add('is-card-scrolling');
      } else {
        section.classList.remove('is-hero-pinned');
        section.classList.remove('is-card-scrolling');
      }

      if (progress > 0) {
        section.classList.add('is-panel-overlay');
      } else {
        section.classList.remove('is-panel-overlay');
      }
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function scheduleMeasure() {
      window.requestAnimationFrame(function () {
        measure();
        requestUpdate();
      });
    }

    scheduleMbCardMeasure = scheduleMeasure;
    scheduleMeasure();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', scheduleMeasure, { passive: true });
    window.addEventListener('load', scheduleMeasure, { passive: true });

    if (scratchImg && !scratchImg.complete) {
      scratchImg.addEventListener('load', scheduleMeasure, { once: true });
    }
  }

  function initPrizeTooltips() {
    section.querySelectorAll('.spring-sale-pre-part1__prize-info-btn').forEach(function (button) {
      var tooltip = button.parentElement.querySelector('.spring-sale-pre-part1__prize-tooltip');
      if (!tooltip) return;

      button.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = tooltip.classList.contains('is-visible');
        section.querySelectorAll('.spring-sale-pre-part1__prize-tooltip.is-visible').forEach(function (node) {
          node.classList.remove('is-visible');
        });
        section.querySelectorAll('.spring-sale-pre-part1__prize-info-btn[aria-expanded="true"]').forEach(function (node) {
          node.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          tooltip.classList.add('is-visible');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.spring-sale-pre-part1__prize-info-wrap')) return;
      section.querySelectorAll('.spring-sale-pre-part1__prize-tooltip.is-visible').forEach(function (node) {
        node.classList.remove('is-visible');
      });
      section.querySelectorAll('.spring-sale-pre-part1__prize-info-btn[aria-expanded="true"]').forEach(function (node) {
        node.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function showResult(prizeIndex) {
    if (!winWrapper) return;

    var result = prizeMap[prizeIndex];
    if (!result) return;

    var copyEl = section.querySelector('.spring-sale-pre-part1__copy');
    var titleEl = winWrapper.querySelector('.title');
    var text1El = winWrapper.querySelector('.text-1');
    var iconEl = winWrapper.querySelector('.spring-sale-pre-part1__win-icon');

    winWrapper.setAttribute('data-prize', String(prizeIndex));
    if (titleEl) titleEl.innerHTML = result.title;
    if (text1El) {
      text1El.innerHTML = result.text;
      text1El.style.display = 'block';
    }
    if (iconEl) iconEl.style.display = result.isWin ? 'none' : 'block';

    section.classList.add('is-prize-shown');
    if (copyEl) copyEl.classList.add('is-prize-shown');
    winWrapper.hidden = false;
    winWrapper.classList.add('is-visible');
    if (scheduleMbCardMeasure) scheduleMbCardMeasure();
  }

  function showNotice(message) {
    if (!resultNotice) return;
    resultNotice.textContent = message;
    resultNotice.classList.add('is-visible');
  }

  function hideNotice() {
    if (!resultNotice) return;
    resultNotice.textContent = '';
    resultNotice.classList.remove('is-visible');
  }

  function getScratchCoverUrl() {
    return isMobile() ? config.scratchCoverMb : config.scratchCoverPc;
  }

  function destroyScratchInstance() {
    if (scratchInstance && typeof scratchInstance.destroy === 'function') {
      scratchInstance.destroy();
    }
    scratchInstance = null;
  }

  function initScratchCanvas() {
    if (!modalCanvas) return null;

    var wrap = modalCanvas.parentElement;
    var coverUrl = getScratchCoverUrl();
    var ctx = modalCanvas.getContext('2d');
    var isDrawing = false;
    var revealed = false;
    var autoCompleting = false;
    var lastX = 0;
    var lastY = 0;
    var listeners = [];

    function addListener(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      listeners.push([target, type, handler, options]);
    }

    function resizeCanvas() {
      modalCanvas.style.width = '';
      modalCanvas.style.height = '';
      var wrapRect = wrap.getBoundingClientRect();
      var canvasRect = modalCanvas.getBoundingClientRect();
      var width = canvasRect.width || wrapRect.width * SCRATCH_WIDTH_RATIO;
      var height = canvasRect.height || wrapRect.height * SCRATCH_HEIGHT_RATIO;
      modalCanvas.width = Math.max(1, Math.round(width));
      modalCanvas.height = Math.max(1, Math.round(height));
    }

    function drawCover() {
      return new Promise(function (resolve) {
        var image = new Image();
        image.onload = function () {
          ctx.globalCompositeOperation = 'source-over';
          ctx.clearRect(0, 0, modalCanvas.width, modalCanvas.height);
          ctx.drawImage(image, 0, 0, modalCanvas.width, modalCanvas.height);
          resolve();
        };
        image.onerror = function () {
          ctx.fillStyle = '#c8c8c8';
          ctx.fillRect(0, 0, modalCanvas.width, modalCanvas.height);
          resolve();
        };
        image.src = coverUrl;
      });
    }

    function getScratchedRatio() {
      var pixels = ctx.getImageData(0, 0, modalCanvas.width, modalCanvas.height).data;
      var transparent = 0;
      var total = modalCanvas.width * modalCanvas.height;
      for (var i = 3; i < pixels.length; i += 4) {
        if (pixels[i] < 50) transparent++;
      }
      return transparent / total;
    }

    function getScratchLineWidth() {
      return isMobile() ? 30 : 40;
    }

    function getScratchDotRadius() {
      return isMobile() ? 15 : 20;
    }

    function pointerPosition(event) {
      var rect = modalCanvas.getBoundingClientRect();
      var scaleX = modalCanvas.width / rect.width;
      var scaleY = modalCanvas.height / rect.height;
      var point = event.touches && event.touches[0] ? event.touches[0] : event;
      return {
        x: (point.clientX - rect.left) * scaleX,
        y: (point.clientY - rect.top) * scaleY
      };
    }

    function revealPrize() {
      if (revealed) return;
      revealed = true;
      autoCompleting = false;
      scratchRevealed = true;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillRect(0, 0, modalCanvas.width, modalCanvas.height);
      modalCanvas.style.opacity = '0';
      modalCanvas.style.pointerEvents = 'none';
      modalCanvas.style.visibility = 'hidden';
      if (modalHint) modalHint.hidden = true;
      if (modalResult) modalResult.hidden = false;
      if (modalDialog) modalDialog.classList.add('is-scratch-revealed');
      showModalPrizeVisual();
    }

    function startAutoCompleteScratch() {
      if (revealed || autoCompleting) return;
      autoCompleting = true;
      isDrawing = false;

      function animate() {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
        ctx.fillRect(0, 0, modalCanvas.width, modalCanvas.height);
        if (getScratchedRatio() < SCRATCH_COMPLETE_RATIO) {
          window.requestAnimationFrame(animate);
        } else {
          revealPrize();
        }
      }

      animate();
    }

    function drawScratch(x, y, isDrag) {
      if (revealed || autoCompleting) return;

      ctx.globalCompositeOperation = 'destination-out';

      if (isDrag) {
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.lineWidth = getScratchLineWidth();
        ctx.beginPath();
        ctx.moveTo(lastX, lastY);
        ctx.lineTo(x, y);
        ctx.stroke();
      } else {
        ctx.beginPath();
        ctx.arc(x, y, getScratchDotRadius(), 0, Math.PI * 2);
        ctx.fill();
      }

      lastX = x;
      lastY = y;

      if (getScratchedRatio() >= SCRATCH_REVEAL_RATIO) {
        startAutoCompleteScratch();
      }
    }

    function onPointerDown(event) {
      if (revealed || autoCompleting) return;
      isDrawing = true;
      var pos = pointerPosition(event);
      lastX = pos.x;
      lastY = pos.y;
      drawScratch(pos.x, pos.y, false);
      if (event.cancelable) event.preventDefault();
    }

    function onPointerMove(event) {
      if (!isDrawing || revealed || autoCompleting) return;
      var pos = pointerPosition(event);
      drawScratch(pos.x, pos.y, true);
      if (event.cancelable) event.preventDefault();
    }

    function onPointerUp() {
      isDrawing = false;
    }

    resizeCanvas();
    drawCover().then(function () {
      addListener(modalCanvas, 'mousedown', onPointerDown);
      addListener(modalCanvas, 'mousemove', onPointerMove);
      addListener(window, 'mouseup', onPointerUp);
      addListener(modalCanvas, 'mouseleave', onPointerUp);
      addListener(modalCanvas, 'touchstart', onPointerDown, { passive: false });
      addListener(modalCanvas, 'touchmove', onPointerMove, { passive: false });
      addListener(window, 'touchend', onPointerUp);
    });

    return {
      destroy: function () {
        listeners.forEach(function (entry) {
          entry[0].removeEventListener(entry[1], entry[2], entry[3]);
        });
        listeners = [];
      },
      forceReveal: startAutoCompleteScratch
    };
  }

  function hideModalPrizeVisual() {
    if (modalHeart) modalHeart.hidden = true;
    if (modalPrizeMedia) {
      modalPrizeMedia.hidden = true;
      modalPrizeMedia.innerHTML = '';
    }
  }

  function showModalPrizeVisual() {
    var result = currentPrizeResult;
    if (!result) return;

    hideModalPrizeVisual();

    if (!result.isWin) {
      if (modalHeart) modalHeart.hidden = false;
      return;
    }

    if (modalPrizeMedia && result.image) {
      modalPrizeMedia.innerHTML =
        '<img src="' +
        result.image +
        '" alt="" width="304" height="280" loading="eager" decoding="async">';
      modalPrizeMedia.hidden = false;
    }
  }

  function setModalPrize(prizeIndex) {
    var result = prizeMap[prizeIndex];
    if (!result) return;

    currentPrizeResult = result;

    if (modalPrizeTitle) modalPrizeTitle.innerHTML = result.title;
    if (modalPrizeText) {
      modalPrizeText.innerHTML = result.text;
      modalPrizeText.hidden = !result.text;
    }
    if (modalResult) {
      modalResult.classList.toggle('is-no-prize', !result.isWin);
      modalResult.classList.toggle('is-modal-prize-1', prizeIndex === 0);
      modalResult.classList.toggle('is-modal-prize-2', prizeIndex === 1);
      modalResult.classList.toggle('is-modal-prize-3', prizeIndex === 2);
    }

    hideModalPrizeVisual();
  }

  function finishCloseModal() {
    if (!modal) return;

    if (modalCloseTimer) {
      window.clearTimeout(modalCloseTimer);
      modalCloseTimer = null;
    }

    modal.classList.remove('is-open', 'is-closing');
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('spring-sale-pre-part1-modal-open');
    destroyScratchInstance();

    if (modalDialog) modalDialog.classList.remove('is-scratch-revealed');

    if (scratchRevealed && pendingPrizeIndex !== null) {
      showResult(pendingPrizeIndex);
    }

    pendingPrizeIndex = null;
    currentPrizeResult = null;
    hideModalPrizeVisual();
  }

  function revealModal(prizeIndex) {
    if (!modal) return;

    pendingPrizeIndex = prizeIndex;
    scratchRevealed = false;
    setModalPrize(prizeIndex);

    if (modalHint) modalHint.hidden = false;
    if (modalResult) modalResult.hidden = true;
    if (modalDialog) modalDialog.classList.remove('is-scratch-revealed');
    if (modalCanvas) {
      modalCanvas.style.opacity = '1';
      modalCanvas.style.pointerEvents = 'auto';
      modalCanvas.style.visibility = 'visible';
      modalCanvas.style.width = '';
      modalCanvas.style.height = '';
    }

    modal.classList.remove('is-closing');
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('spring-sale-pre-part1-modal-open');

    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');

      window.requestAnimationFrame(function () {
        destroyScratchInstance();
        scratchInstance = initScratchCanvas();
      });
    });
  }

  function openModal(prizeIndex) {
    if (!modal) return;

    if (modalCloseTimer) {
      window.clearTimeout(modalCloseTimer);
      modalCloseTimer = null;
    }

    preloadModalAssets(prizeIndex).then(function () {
      revealModal(prizeIndex);
    });
  }

  function closeModal() {
    if (!modal || modal.hidden) return;

    if (!modal.classList.contains('is-open')) {
      finishCloseModal();
      return;
    }

    if (modal.classList.contains('is-closing')) return;

    modal.classList.remove('is-open');
    modal.classList.add('is-closing');

    modalCloseTimer = window.setTimeout(function () {
      modalCloseTimer = null;
      finishCloseModal();
    }, MODAL_TRANSITION_MS);
  }

  if (modal) {
    modal.querySelectorAll('[data-modal-close]').forEach(function (node) {
      node.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function md5Hex(input) {
    function cmn(q, a, b, x, s, t) {
      a = add32(add32(a, q), add32(x, t));
      return add32((a << s) | (a >>> (32 - s)), b);
    }
    function ff(a, b, c, d, x, s, t) {
      return cmn((b & c) | (~b & d), a, b, x, s, t);
    }
    function gg(a, b, c, d, x, s, t) {
      return cmn((b & d) | (c & ~d), a, b, x, s, t);
    }
    function hh(a, b, c, d, x, s, t) {
      return cmn(b ^ c ^ d, a, b, x, s, t);
    }
    function ii(a, b, c, d, x, s, t) {
      return cmn(c ^ (b | ~d), a, b, x, s, t);
    }
    function md5cycle(x, k) {
      var a = x[0];
      var b = x[1];
      var c = x[2];
      var d = x[3];
      a = ff(a, b, c, d, k[0], 7, -680876936);
      d = ff(d, a, b, c, k[1], 12, -389564586);
      c = ff(c, d, a, b, k[2], 17, 606105819);
      b = ff(b, c, d, a, k[3], 22, -1044525330);
      a = ff(a, b, c, d, k[4], 7, -176418897);
      d = ff(d, a, b, c, k[5], 12, 1200080426);
      c = ff(c, d, a, b, k[6], 17, -1473231341);
      b = ff(b, c, d, a, k[7], 22, -45705983);
      a = ff(a, b, c, d, k[8], 7, 1770035416);
      d = ff(d, a, b, c, k[9], 12, -1958414417);
      c = ff(c, d, a, b, k[10], 17, -42063);
      b = ff(b, c, d, a, k[11], 22, -1990404162);
      a = ff(a, b, c, d, k[12], 7, 1804603682);
      d = ff(d, a, b, c, k[13], 12, -40341101);
      c = ff(c, d, a, b, k[14], 17, -1502002290);
      b = ff(b, c, d, a, k[15], 22, 1236535329);
      a = gg(a, b, c, d, k[1], 5, -165796510);
      d = gg(d, a, b, c, k[6], 9, -1069501632);
      c = gg(c, d, a, b, k[11], 14, 643717713);
      b = gg(b, c, d, a, k[0], 20, -373897302);
      a = gg(a, b, c, d, k[5], 5, -701558691);
      d = gg(d, a, b, c, k[10], 9, 38016083);
      c = gg(c, d, a, b, k[15], 14, -660478335);
      b = gg(b, c, d, a, k[4], 20, -405537848);
      a = gg(a, b, c, d, k[9], 5, 568446438);
      d = gg(d, a, b, c, k[14], 9, -1019803690);
      c = gg(c, d, a, b, k[3], 14, -187363961);
      b = gg(b, c, d, a, k[8], 20, 1163531501);
      a = gg(a, b, c, d, k[13], 5, -1444681467);
      d = gg(d, a, b, c, k[2], 9, -51403784);
      c = gg(c, d, a, b, k[7], 14, 1735328473);
      b = gg(b, c, d, a, k[12], 20, -1926607734);
      a = hh(a, b, c, d, k[5], 4, -378558);
      d = hh(d, a, b, c, k[8], 11, -2022574463);
      c = hh(c, d, a, b, k[11], 16, 1839030562);
      b = hh(b, c, d, a, k[14], 23, -35309556);
      a = hh(a, b, c, d, k[1], 4, -1530992060);
      d = hh(d, a, b, c, k[4], 11, 1272893353);
      c = hh(c, d, a, b, k[7], 16, -155497632);
      b = hh(b, c, d, a, k[10], 23, -1094730640);
      a = hh(a, b, c, d, k[13], 4, 681279174);
      d = hh(d, a, b, c, k[0], 11, -358537222);
      c = hh(c, d, a, b, k[3], 16, -722521979);
      b = hh(b, c, d, a, k[6], 23, 76029189);
      a = hh(a, b, c, d, k[9], 4, -640364487);
      d = hh(d, a, b, c, k[12], 11, -421815835);
      c = hh(c, d, a, b, k[15], 16, 530742520);
      b = hh(b, c, d, a, k[2], 23, -995338651);
      a = ii(a, b, c, d, k[0], 6, -198630844);
      d = ii(d, a, b, c, k[7], 10, 1126891415);
      c = ii(c, d, a, b, k[14], 15, -1416354905);
      b = ii(b, c, d, a, k[5], 21, -57434055);
      a = ii(a, b, c, d, k[12], 6, 1700485571);
      d = ii(d, a, b, c, k[3], 10, -1894986606);
      c = ii(c, d, a, b, k[10], 15, -1051523);
      b = ii(b, c, d, a, k[1], 21, -2054922799);
      a = ii(a, b, c, d, k[8], 6, 1873313359);
      d = ii(d, a, b, c, k[15], 10, -30611744);
      c = ii(c, d, a, b, k[6], 15, -1560198380);
      b = ii(b, c, d, a, k[13], 21, 1309151649);
      a = ii(a, b, c, d, k[4], 6, -145523070);
      d = ii(d, a, b, c, k[11], 10, -1120210379);
      c = ii(c, d, a, b, k[2], 15, 718787259);
      b = ii(b, c, d, a, k[9], 21, -343485551);
      x[0] = add32(a, x[0]);
      x[1] = add32(b, x[1]);
      x[2] = add32(c, x[2]);
      x[3] = add32(d, x[3]);
    }
    function add32(a, b) {
      return (a + b) & 4294967295;
    }
    function md5blk(s) {
      var md5blks = [];
      for (var i = 0; i < 64; i += 4) {
        md5blks[i >> 2] =
          s.charCodeAt(i) +
          (s.charCodeAt(i + 1) << 8) +
          (s.charCodeAt(i + 2) << 16) +
          (s.charCodeAt(i + 3) << 24);
      }
      return md5blks;
    }
    function md51(s) {
      var n = s.length;
      var state = [1732584193, -271733879, -1732584194, 271733878];
      var i;
      for (i = 64; i <= n; i += 64) {
        md5cycle(state, md5blk(s.substring(i - 64, i)));
      }
      s = s.substring(i - 64);
      var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      for (i = 0; i < s.length; i += 1) {
        tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
      }
      tail[i >> 2] |= 128 << ((i % 4) << 3);
      if (i > 55) {
        md5cycle(state, tail);
        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
      tail[14] = n * 8;
      md5cycle(state, tail);
      return state;
    }
    function rhex(n) {
      var hex = '0123456789abcdef';
      var s = '';
      for (var j = 0; j < 4; j += 1) {
        s += hex.charAt((n >> (j * 8 + 4)) & 15) + hex.charAt((n >> (j * 8)) & 15);
      }
      return s;
    }
    return md51(String(input))
      .map(rhex)
      .join('');
  }

  var pointsToken = '';
  var pointsTokenExpiresAt = 0;

  function buildLotterySign() {
    var actId = config.actId || 168;
    var signSecret = config.signSecret || 'e261b3ff16598f7c2adc50fb2dc8e12d';
    return md5Hex(String(actId) + '|' + signSecret);
  }

  async function fetchLotteryToken(sign) {
    var response = await fetch(config.tokenUrl || 'https://global.shokz.com/lottery/start', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        actId: config.actId || 168,
        sign: sign
      })
    });
    var result = await response.json().catch(function () {
      return null;
    });

    if (!response.ok || !result || result.code !== 200 || !result.data || !result.data.token) {
      var actStatus = result && result.data ? result.data.act_status : '';
      throw new Error(actStatus || (result && result.msg) || 'Token request failed');
    }

    return result.data.token;
  }

  async function fetchPointsToken() {
    var response = await fetch(config.pointsTokenApi || 'https://loyalty.shokz.com/api/web/auth/token', {
      method: 'POST',
      headers: {
        'X-Site': config.pointsSite || 'jp',
        'Api-Key': config.pointsApiKey || ''
      }
    });
    var result = await response.json().catch(function () {
      return null;
    });

    if (!response.ok || !result || result.code !== 200 || !result.data || !result.data.token) {
      throw new Error((result && result.msg) || 'Points token request failed');
    }

    pointsToken = result.data.token;
    var expiresIn = Number(result.data.expires_in || result.data.expireSeconds || result.data.expiresIn || 3600);
    if (!expiresIn || expiresIn < 0) expiresIn = 3600;
    pointsTokenExpiresAt = Date.now() + expiresIn * 1000;
  }

  async function postEarnActivity(email) {
    var body = new FormData();
    body.append('email', email);
    body.append('activity_code', config.pointsActivityCode);
    body.append('activity_id', config.pointsActivityId);

    var response = await fetch(config.pointsApi, {
      method: 'POST',
      headers: {
        'X-Site': config.pointsSite || 'jp',
        Authorization: 'Bearer ' + pointsToken
      },
      body: body
    });
    var result = await response.json().catch(function () {
      return null;
    });
    return { response: response, result: result };
  }

  function assertPointsGranted(payload) {
    var response = payload.response;
    var result = payload.result;
    var skipped = result && result.data && result.data.skipped;
    var earned = result && result.data ? Number(result.data.earned_points) : NaN;

    if (!response.ok || !result || result.code !== 200) {
      throw new Error((result && result.msg) || 'Points earn request failed');
    }

    if (Array.isArray(skipped) && skipped.length && !(earned > 0)) {
      throw new Error('Points rule skipped: ' + JSON.stringify(skipped));
    }
  }

  async function earnPointsRequest(email) {
    if (!config.pointsApi || !config.pointsTokenApi) return;
    if (!config.pointsActivityCode || !config.pointsActivityId) return;

    if (!pointsToken || Date.now() >= pointsTokenExpiresAt) {
      await fetchPointsToken();
    }

    var payload = await postEarnActivity(email);
    var status = payload.response ? payload.response.status : 0;
    if (status === 401 || status === 403) {
      pointsToken = '';
      pointsTokenExpiresAt = 0;
      await fetchPointsToken();
      payload = await postEarnActivity(email);
    }

    assertPointsGranted(payload);
  }

  function earnPoints(email) {
    earnPointsRequest(email).catch(function (error) {
      console.error('Autumn sale points earn failed:', error);
    });
  }

  function drawPrizeIds(drawData) {
    if (drawData == null || typeof drawData !== 'object') {
      return [Number(drawData)];
    }
    return [Number(drawData.priceId), Number(drawData.actPriceId)];
  }

  function isPointsPrize(drawData) {
    var pointsPriceId = Number(config.pointsPrizePriceId || 1168);
    return drawPrizeIds(drawData).indexOf(pointsPriceId) !== -1;
  }

  function resolvePrizeIndex(drawData) {
    var prizePriceIds = config.prizePriceIds || [1166, 1167, 1168];
    var ids = drawPrizeIds(drawData);
    for (var i = 0; i < ids.length; i++) {
      var index = prizePriceIds.indexOf(ids[i]);
      if (index !== -1) return index;
    }
    return null;
  }

  function handleActStatus(actStatus) {
    if (actStatus === 'no_finish') {
      showNotice('このメールアドレスではすでに応募済みです。');
    } else if (actStatus === 'no_finish_ip') {
      showNotice('The number of requests from the same IP address exceeded the limit.');
    } else if (actStatus === 'no_login') {
      showNotice('Unable to participate. Please check your email and try again.');
    } else if (actStatus === 'no_act') {
      showNotice('This promotion is currently unavailable.');
    } else if (actStatus === 'sign_invalid') {
      showNotice('An unexpected error occurred. Please try again later.');
    } else {
      showNotice('An unexpected error occurred. Please try again later.');
    }
  }

  async function draw(email) {
    var sign = buildLotterySign();
    var token = await fetchLotteryToken(sign);
    var response = await fetch(config.drawUrl || 'https://global.shokz.com/lottery/openapi_v3', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        mbId: email,
        actId: config.actId || 168,
        usageScenarios: config.usageScenarios || 'cs',
        sign: sign,
        token: token
      })
    });

    if (!response.ok) {
      throw new Error('HTTP error! Status: ' + response.status);
    }

    return response.json();
  }

  function trackSubscribe(email, status) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'subscribe',
      event_parameters: {
        module: config.subscribeModule || 'subscribe_draw',
        status: status,
        email: email || '',
        content_name: ''
      }
    });
  }

  var subscribeGaTracked = false;
  var subscribeGaResetTimer = null;

  function getSubscribeEmailFromCopy() {
    if (!emailKlv) return '';
    var emailInput =
      emailKlv.querySelector('input[type="email"]') ||
      emailKlv.querySelector('input[name="email"]') ||
      emailKlv.querySelector('input[autocomplete="email"]') ||
      emailKlv.querySelector('input');
    return emailInput ? String(emailInput.value || '').trim() : '';
  }

  function isKlaviyoSubmitButton(button) {
    if (!button || button.tagName !== 'BUTTON') return false;
    if (!button.closest('.spring-sale-pre-part1__email-klv')) return false;
    if (button.classList.contains('go4147362152')) return true;
    var classList = Array.prototype.slice.call(button.classList);
    for (var i = 0; i < classList.length; i++) {
      if (/^go\d+$/.test(classList[i])) return true;
    }
    return button.getAttribute('type') === 'submit';
  }

  function fireSubscribeTracking(email, status) {
    if (subscribeGaTracked) return;
    subscribeGaTracked = true;
    trackSubscribe(email, status);
    if (subscribeGaResetTimer) clearTimeout(subscribeGaResetTimer);
    subscribeGaResetTimer = window.setTimeout(function () {
      subscribeGaTracked = false;
      subscribeGaResetTimer = null;
    }, 2000);
  }

  if (!lotteryPreviewMode && emailKlv) {
    emailKlv.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!isKlaviyoSubmitButton(button)) return;
      fireSubscribeTracking(getSubscribeEmailFromCopy(), getSubscribeEmailFromCopy() ? 'success' : 'fail');
    });
  }

  window.addEventListener('klaviyoForms', async function (event) {
    if (lotteryPreviewMode) return;
    if (event.detail.type !== 'submit' || event.detail.formId !== (config.klaviyoFormId || 'WuEBXP')) return;

    var email = (event.detail.metaData && event.detail.metaData.$email) || getSubscribeEmailFromCopy();
    fireSubscribeTracking(email, email ? 'success' : 'fail');
    if (!email) return;

    hideNotice();

    try {
      var drawResult = await draw(email);

      if (!drawResult || drawResult.code !== 200) {
        handleActStatus(drawResult && drawResult.data ? drawResult.data.act_status : '');
        return;
      }

      var drawData = drawResult.data || {};
      var drawStatus = drawData.act_status || drawData.status;
      if (drawStatus && drawStatus !== 'ok') {
        handleActStatus(drawStatus);
        return;
      }

      var prizeIndex = resolvePrizeIndex(drawData);

      if (prizeIndex !== null) {
        if (isPointsPrize(drawData)) {
          earnPoints(email);
        }
        openModal(prizeIndex);
      } else {
        showNotice('An unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      var errorStatus = error && error.message ? String(error.message) : '';
      if (
        errorStatus === 'sign_invalid' ||
        errorStatus === 'no_login' ||
        errorStatus === 'no_act' ||
        errorStatus === 'no_finish' ||
        errorStatus === 'no_finish_ip'
      ) {
        handleActStatus(errorStatus);
        return;
      }
      showNotice('An unexpected error occurred. Please try again later.');
    }
  });

  scheduleModalAssetPreload();

  if (emailKlv) {
    emailKlv.addEventListener('focusin', scheduleModalAssetPreload, { once: true });
  }

  initMbCardScroll();
  initPrizeTooltips();

  (function () {
    var impressionTarget =
      section.querySelector('.spring-sale-pre-part1__hero-pin') ||
      section.querySelector('.spring-sale-pre-part1__hero') ||
      section;
    var impressionModule = 'subscribe_draw';
    var impressionOptions = {
      target: impressionTarget,
      once: true,
      threshold: 0.2,
      eventParameters: { module: impressionModule }
    };

    if (typeof window.observeModuleImpression === 'function') {
      window.observeModuleImpression(impressionOptions);
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      function isModuleBottomInViewport(el) {
        if (!el) return false;
        var rect = el.getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return rect.bottom > 0 && rect.bottom <= windowHeight;
      }

      function handleImpressionTrack() {
        if (section.dataset.subscribeDrawImpressionTracked === 'true') return;
        if (!isModuleBottomInViewport(impressionTarget)) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'module_impression',
          event_parameters: { module: impressionModule }
        });
        section.dataset.subscribeDrawImpressionTracked = 'true';
        window.removeEventListener('scroll', handleImpressionTrack);
        window.removeEventListener('resize', handleImpressionTrack);
      }

      window.addEventListener('scroll', handleImpressionTrack, { passive: true });
      window.addEventListener('resize', handleImpressionTrack, { passive: true });
      handleImpressionTrack();
      return;
    }

    var impressionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'module_impression',
            event_parameters: { module: impressionModule }
          });
          impressionObserver.disconnect();
        });
      },
      { threshold: impressionOptions.threshold }
    );
    impressionObserver.observe(impressionTarget);
  })();

  function getBenefitsScrollOffset() {
    var offset = 0;
    var header = document.querySelector('.site-header');
    if (header) {
      offset += header.offsetHeight;
    }

    var nav = document.getElementById('spring-sale-pre-nav');
    if (nav) {
      offset += nav.offsetHeight;
    }

    return offset + 32;
  }

  function resolveBenefitsTarget(selector) {
    var href = selector || config.benefitsLinkUrl || '#discount-info';
    if (!href || href === '#') {
      href = '#discount-info';
    }

    return (
      document.querySelector(href) ||
      document.querySelector('[data-jump-scroll-name="' + href.replace('#', '') + '"]')
    );
  }

  function scrollToBenefitsTarget(selector) {
    var target = resolveBenefitsTarget(selector);
    if (!target) return;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    var top = target.getBoundingClientRect().top + scrollTop - getBenefitsScrollOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
  }

  function handleBenefitsLinkClick(event) {
    var link = event.currentTarget;
    var href = link.getAttribute('href');
    if (!href || href === '#') {
      href = config.benefitsLinkUrl || '#discount-info';
    }

    event.preventDefault();

    if (link.classList.contains('spring-sale-pre-part1__modal-cta') && modal && modal.classList.contains('is-open')) {
      window.setTimeout(function () {
        scrollToBenefitsTarget(href);
      }, 50);
      return;
    }

    scrollToBenefitsTarget(href);
  }

  section.querySelectorAll('.spring-sale-pre-part1__benefits-link').forEach(function (link) {
    link.addEventListener('click', handleBenefitsLinkClick);
  });

  if (modal) {
    modal.querySelectorAll('.spring-sale-pre-part1__modal-cta').forEach(function (link) {
      link.addEventListener('click', handleBenefitsLinkClick);
    });
  }
});
